import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { UserFormVM } from './user-form.viewmodel';
import { UserFormPresentation } from './_user-form-presentation/user-form-presentation';

interface IProps {
    fetchUsersList: () => void;
    closeEditUserForm: (email: string) => void;
    username?: string;
}

const UserFormContainer = withViewModel(
    UserFormPresentation,
    (props: IProps) => {
        const {fetchUsersList, closeEditUserForm, username} = props;
        const userFormVM = new UserFormVM(fetchUsersList, closeEditUserForm);
        userFormVM.setUser(username);
        return userFormVM;
    },
    () => []
);

export { UserFormContainer as UserForm };
